try {
	if (this.location.pathname.indexOf('/marketplace/picker') === -1) {
this.top.location !== this.location && (this.top.location = this.location);
	}
} catch (e) { }
function force_numbers(evt){
	var charCode = (evt.which) ? evt.which : event.keyCode
	if (charCode > 31 && (charCode < 48 || charCode > 57))
		return false;
	return true;
}
window['del_hide'] = 0;	// TODO: is this necessary?

function get_last_textarea(ref){
	if (ref)
		return $($(ref).getAttribute('ref'));
	return $(($('parts')?$('parts').getAttribute('data-ref'):'product[formula]'));
}
function add_to_ck(rep_text, delimiters, textarea_ref) {
	var text_to_add = (delimiters ? delimiters.slice(0, 1) : '') + rep_text + (delimiters ? delimiters.slice(-1) : '');
	if (CKEDITOR.instances[textarea_ref] && CKEDITOR.instances[textarea_ref].mode=='wysiwyg')
		CKEDITOR.instances[textarea_ref].insertText(text_to_add);
	else {
		if (CKEDITOR.instances[textarea_ref])
			var textarea = CKEDITOR.instances[textarea_ref].container.$.down('.cke_source');
		else
			var textarea = get_last_textarea(textarea_ref);
		if (textarea) {
			textarea.focus();
			if (!!document.selection)
				var sel_text = document.selection.createRange().text;
			else if (!!textarea.setSelectionRange)
				var sel_text = textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
			else
				var sel_text = '';
			var scroll_top = textarea.scrollTop;
			if (!!document.selection) {
				var range = document.selection.createRange();
				range.text = (delimiters ? delimiters.slice(0, 1) : '') + rep_text + (delimiters ? delimiters.slice(-1) : '');
				range.select();
			} else if (!!textarea.setSelectionRange) {
				var selection_start = textarea.selectionStart;
				textarea.value = textarea.value.substring(0, selection_start)
					+ (delimiters ? delimiters.slice(0, 1) : '') + rep_text + (delimiters ? delimiters.slice(-1) : '')
					+ textarea.value.substring(textarea.selectionEnd);
				textarea.setSelectionRange(selection_start + rep_text.length + (delimiters ? 2 : 0), selection_start + rep_text.length + (delimiters ? 2 : 0));
			}
			//textarea.scrollTop = scroll_top;
			textarea.focus();
		}
	}
	return false;
}
function add_to_focused(rep_text, delimiters, textarea_ref){
	var textarea = get_last_textarea(textarea_ref);
	var cut_length = 0;
	if(!delimiters && textarea)
		delimiters = textarea.getAttribute('data-delimiters'); // The simplest way to enable Proxy Variables on Part Export Formulas without a lot of functional rewriting
	if (delimiters)
		cut_length = delimiters.length/2;

	try{
		if (typeof (ace) !== 'undefined' && textarea.id && !!document.getElementById('editor-' + textarea.id)) {
			const editor = ace.edit('editor-' + textarea.id);
			const textToAdd = (delimiters ? delimiters.slice(0, cut_length) : '') + rep_text + (delimiters ? delimiters.slice(-1 * cut_length) : '');
			editor.session.insert(editor.getCursorPosition(), textToAdd)
			editor.focus();
			return false;
		}
	}
	catch(e){
		console.log(rep_text, '  rep_text');
		console.log(delimiters, '  delimiters');
		console.log(textarea_ref, '  textarea_ref');
		console.log(e, '  e');
	}

	
	try{
		if (textarea) {
		} else if(typeof(CKEDITOR) !== 'undefined' && CKEDITOR.instances && CKEDITOR.instances.action_email){
			var text_to_add = (delimiters ? delimiters.slice(0, cut_length) : '') + rep_text + (delimiters ? delimiters.slice(-1*cut_length) : '');
			if (CKEDITOR.instances.action_email.mode=='wysiwyg') {
				CKEDITOR.instances.action_email.insertText(text_to_add);
				return false;
			}
			else
				var textarea = CKEDITOR.instances.action_email.container.$.down('.cke_source');
		}
		if (textarea) {
			textarea.focus();
			if (!!document.selection)
				var sel_text = document.selection.createRange().text;
			else if (!!textarea.setSelectionRange)
				var sel_text = textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
			else
				var sel_text = '';
			var scroll_top = textarea.scrollTop;
			if (!!document.selection) {
				var range = document.selection.createRange();
				range.text = (delimiters ? delimiters.slice(0, cut_length) : '') + rep_text + (delimiters ? delimiters.slice(-1*cut_length) : '');
				range.select();
			} else if (!!textarea.setSelectionRange) {
				var selection_start = textarea.selectionStart;
				textarea.value = textarea.value.substring(0, selection_start)
					+ (delimiters ? delimiters.slice(0, cut_length) : '') + rep_text + (delimiters ? delimiters.slice(-1*cut_length) : '')
					+ textarea.value.substring(textarea.selectionEnd);
				textarea.setSelectionRange(selection_start + rep_text.length + (delimiters ? delimiters.length : 0), selection_start + rep_text.length + (delimiters ? delimiters.length : 0));
			}
			//textarea.scrollTop = scroll_top;
			textarea.focus();
		}

		return false;
	}
	catch(e){
		console.log(rep_text, '  rep_text');
		console.log(delimiters, '  delimiters');
		console.log(textarea_ref, '  textarea_ref');
		console.log(e, '  e');
	}
}

function init_product_quick_search_forms() {
	if (typeof product_quick_search_init !== 'function') return;
	const $folders = am.$('.order-folder');
	if ($folders.length > 0) {
		$folders.each((index, element) => {
			product_quick_search_init(element.id);
			MoxForm(element);
		});
	} else {
		product_quick_search_init();
	}
}

document.observe("dom:loaded", function() {
	if (typeof sorttable !== 'undefined') sorttable.init(function(id){
		var table = this.up('table');
		if(table.hasClassName('sub_sortable'))
			table = table.up('table');
		var name = table.id;
		if(!name)
			return;

		var match = location.href.match(/\/(\d+)\//);
		if (match) {
			var a = match[1];
			var rows = [];
			if(table.tBodies < 2)
				rows = Array.prototype.slice.call(table.tBodies[0].rows);
			else
			{
				Array.prototype.slice.call(table.tBodies).each(function(row)
				{
					rows.push(row.down('tr'));
				});
			}
			var ids = [];
			rows.each(function(row){
				if (row.id.length)
					ids.push(row.id.slice(row.id.match(/[\d_]+$/).index + 1));
			});
			var name = table.id;
			if(name)
			{
				new Ajax.Request(['/ajax/sort_order', name.slice(0, name.indexOf('_')), ''].join('/'), {
					method : 'post', parameters: {
						'parent_id': a,
						'group' : name.slice(name.match(/[\d_]+$/).index + 1),
						'ids': ids.join()
					}
				});
			}
		}
	});
	var list = $$('form.watchform');
	if(list.length){
		list.push($('rightside'));	// only include the rightside if there is a main form -- eg, not liveTable filters
		GUI.loss_prevention(list);
	}
	// DEV-12402: the lite public bundle (js-public) ships without MoxForm — an unguarded
	// reference here threw on dom:loaded and killed the rest of this handler on
	// public/login|password|terms.
	if (typeof MoxForm !== 'undefined') {
		for(var i=0;i<document.forms.length;i++){
			document.forms[i].mox = new MoxForm(document.forms[i]);
		}
	}
		
	$$('form.am-settingsForm').each(function(form) {
		form.setAttribute('onsubmit', 'return false;');
	});
	
	if($('permissions')){
		$('permissions').select('.cb3').each(function(o){
			o.update('<br/>');
			cb3_set_value(o, Number($(o.getAttribute('rel')).value));
			o.observe('click', function(e){
				var t = $(e.element().getAttribute('rel'));
				t.value = (t.value + 1) % 3;
				cb3_set_value(e.element(), Number(t.value));
			});
		});
	}
	if (typeof lTableInit !== 'undefined') lTableInit();	// livetable.js — absent from the lite public bundle (DEV-12402)
	$$('.filter').each(function(o){
		install_filter_observers(o);
	});
	var valid = document.forms[0]?new Validation(document.forms[0]):null;
	document.observe('mouseover', function(e){
		sliderChk(e);
	});
	if (typeof quickfind_init !== 'undefined') quickfind_init();	// quickfind.js — absent from the lite public bundle (DEV-12402)
	init_product_quick_search_forms();

	onresize = onload = function(){ reset_viewport_calcs(); };

	//initialize lightbox, so it can be used on all pages
	if (typeof initLightbox === 'function')
	initLightbox(function(toSelect, lightbox_activated_by, imageData){
		var img = imageData[0].replace('/big/', '/');	// don't use big images as thumbnails
		if(lightbox_activated_by.up('.pao_pic')){
			var image_to_select = lightbox_activated_by.setStyle('display:none;').up().childElements()[toSelect]
			var select = image_to_select.setStyle('display:block;visibility:visible;')
				.up().setStyle(['background-image:url(', img, ')'].join(''))
				.up().down('select');
			var options = select.select('option');
			while(options[toSelect] && img.indexOf(options[toSelect].getAttribute('rel')) == -1){	// is this loop preferable to ++ alone?
				toSelect++;
			}
			if(img.indexOf('default_transparant') >= 0){
				for (let i = 0; i < options.length; i++) {
					if(imageData[1].replace(/\s+/g, '') == options[i].text.replace(/\s+/g, '')){
						toSelect = i;
					}
				}
			}
			
			if(options[toSelect]){
				select.selectedIndex = toSelect;
			} else {
				console.log('Modal Select Error: correct Select Box Option not found.');
			}
		}
	});
	var is_remake = $('products_section') && $('products_section').hasClassName('quote_section');
	if(is_remake){
		if($('productset'))
		{
			Sortable.create('productset', {tag:'div', handle:'product manual'});
			var order_mouseup = function(ev){
				this.stopObserving('mouseup', order_mouseup);
				setTimeout(zebrify_order, 0);
			};
			var order_mousedown = function(ev){
				if(ev.currentTarget.hasClassName('product manual')){
					this.observe('mouseup', order_mouseup);
				}
			};
			$('productset').select('.product.manual').each(function(dh){	// dh = drag handle
				dh.observe('mousedown', order_mousedown);
			});
		}
		//setTimeout(function(){recalc_prices();}, 0);
	}
	set_in_frame();
	accommodate_chat_plugin();

	var marketingLinks = document.querySelectorAll('a.locked-feature[href]');
	if (marketingLinks.length > 0) {
		var marketingUrl = marketingLinks[0].getAttribute('href');

		marketingLinks.forEach(function (link) {
			link.setAttribute('target', '_blank');
			link.setAttribute('rel', 'noopener noreferrer');
		});

		// Only rehome onclick handlers to the marketing URL when there IS one.
		// When a locked-feature link renders with an empty href, marketingUrl is ''
		// and handler.indexOf('') === 0 matched EVERY element with an onclick
		// (form Save buttons included), rebinding them to window.open('', '_blank')
		// + preventDefault() — i.e. clicking Save silently opened an about:blank tab
		// and never saved. Guard on a non-empty URL so unrelated buttons are untouched.
		if (marketingUrl) {
			document.querySelectorAll('[onclick]').forEach(function (el) {
				var handler = el.getAttribute('onclick') || '';
				if (handler.indexOf(marketingUrl) !== -1) {
					el.onclick = function (e) {
						e.preventDefault();
						window.open(marketingUrl, '_blank');
					};
				}
			});
		}
	}
	if (typeof add_attachment_button_event === 'function') add_attachment_button_event();
});
document.observe("modal:open", function(){
	$$('.calendar_trigger').each(function(c){
		var id = c.getAttribute('rel');
		Calendar.setup({selectHandler: function(cal, sql_date){
			$(id).value = cal.date.print('%b %e, %Y');
			$(id + '_sql').value = sql_date;
			$(id + '_parsed').update(formatDate(sql_date)[0]);
		}, triggerElement : c});
	});
});

function install_filter_observers(ob){
	var table = $(ob.id.replace('-filter',''));
	if(table && table.hasClassName('livetable')){
		ob.select('input:not(.maininput)').each(function(o2){
			o2.observe('keyup', ltFilter);
			if (!o2.classList.contains('text') || o2.readOnly) {
				o2.observe('click', ltFilter);
				o2.observe('pseudo:click', ltFilter);
			}
		});
		ob.select('select:not(.maininput)').each(function(o2){
			o2.observe('change', ltFilter);
		});
	}
}
function sliderChk(e){
	if(!$('toolbar')) return;
	if(e.element().id=='toolbar' || e.element().up('#toolbar')){
		var sliderDestination = 0;
	} else if(Prototype.Browser.IE && e.clientX < 2 ) {
		// do nothing
	} else {
		var sliderDestination = -195;
	}
	if(sliderStatus) clearTimeout(sliderStatus);
	var l = parseInt($('toolbar').getStyle('left'));
	if(l != sliderDestination) slider();
}
function sliderMv(e) {
	if(!$('toolbar')) return;
	var l = parseInt($('toolbar').getStyle('left'));
	var destination = (l == 0 ? -195 : 0);
	$('toolbar').setStyle({'left':destination+'px'});
}
window.activeAjax = 0;
window.ajaxLoadingTimeout = null;
// Prototype Ajax.Responders — handles loading spinner for Prototype Ajax.Request calls
Ajax.Responders.register({
	onCreate: function() {
		window.activeAjax++;
		if ($('loading')) {
			var size = getPageSize();

			$(document.body).addClassName('loadingWait');
			if (!window.ajaxLoadingTimeout) {
				window.ajaxLoadingTimeout = setTimeout(loadingControl, 1000);
			}
		}
	},
	onComplete: function() {
		window.activeAjax = Math.max(0, window.activeAjax - 1);
		if (window.activeAjax === 0) {
			$(document.body).removeClassName('ajld loadingWait');
			if (window.ajaxLoadingTimeout) {
				clearTimeout(window.ajaxLoadingTimeout);
				window.ajaxLoadingTimeout = null;
			}
			if ($('loading')) $('loading').hide();
		}
	}
});
// jQuery AJAX global handlers — mirrors Prototype responders above.
// As Ajax.Request calls are migrated to am.$.ajax, these take over automatically.
// Once all Prototype AJAX is gone, remove the Ajax.Responders block above.
am.$(document).ajaxSend(function() {
	window.activeAjax++;
	if (document.getElementById('loading')) {
		document.body.classList.add('loadingWait');
		if (!window.ajaxLoadingTimeout) {
			window.ajaxLoadingTimeout = setTimeout(loadingControl, 1000);
		}
	}
});
am.$(document).ajaxComplete(function() {
	window.activeAjax = Math.max(0, window.activeAjax - 1);
	if (window.activeAjax === 0) {
		document.body.classList.remove('ajld', 'loadingWait');
		if (window.ajaxLoadingTimeout) {
			clearTimeout(window.ajaxLoadingTimeout);
			window.ajaxLoadingTimeout = null;
		}
		var loadingEl = document.getElementById('loading');
		if (loadingEl) loadingEl.style.display = 'none';
	}
});

// CloudWatch RUM forwarding (DEV-12921). Everything here is a no-op when the RUM
// snippet is not on the page (local env): cwr is the queue function the snippet
// in templates/partials/rum_tracking_*.tpl defines in <head>.
function am_rum_now() {
	return (window.performance && performance.now) ? performance.now() : Date.now();
}
// Custom event; the app monitor must have custom events enabled or RUM drops it.
function am_rum_event(type, data) {
	try { if (typeof window.cwr === 'function') window.cwr('recordEvent', { type: type, data: data }); } catch (e) {}
}
function am_rum_record_error(err) {
	try { if (typeof window.cwr === 'function') window.cwr('recordError', err); } catch (e) {}
}
// An HTTP 4xx/5xx on an ajax call, surfaced as an error so it lands on the RUM
// Errors page with its route and status. The http telemetry counts it too, but
// as a bare failure, and the order-form pricing routes are excluded from that
// telemetry entirely. Status 0 is skipped on purpose: that is an abort (the
// order form aborts superseded requests deliberately) or a network drop, which
// the http telemetry already records where it matters.
function am_rum_http_failure(method, url, status, statusText) {
	if (!status || status < 400) return;
	var e = new Error('HTTP ' + status + (statusText ? ' ' + statusText : '') + ' on '
		+ String(method || 'get').toUpperCase() + ' ' + url);
	e.name = 'AjaxHttpError';
	am_rum_record_error(e);
}
if (window.Ajax && Ajax.Responders) {
	Ajax.Responders.register({
		onComplete: function (request, response) {
			am_rum_http_failure(request.method, request.url, response && response.status, response && response.statusText);
		},
		// Prototype catches an exception thrown inside an onSuccess/onComplete handler
		// and routes it here instead of letting it reach window.onerror, so until now
		// a handler blowing up on a response was invisible to RUM (most call sites
		// only console.log it).
		onException: function (request, exception) {
			am_rum_record_error(exception);
		}
	});
}
am.$(document).ajaxError(function (event, jqXHR, settings) {
	if (!jqXHR || jqXHR.statusText === 'abort') return;
	am_rum_http_failure(settings && settings.type, settings && settings.url, jqXHR.status, jqXHR.statusText);
});
// DEV-12312: a visible skeleton IS the loading state — content-shaped placeholders
// replace the spinner, never accompany it (canon: skeleton says "here is the
// content's shape"; the spinner says "work is happening"). Skeleton emitters call
// this after inserting placeholders so a spinner already raised by an earlier
// request drops immediately; loadingControl calls it so the delayed spinner never
// raises while a skeleton is on screen. Self-cleaning: skeletons are removed when
// content lands, so the next ajax raises the spinner normally.
function am_skeleton_takeover(){
	document.body.classList.remove('ajld', 'loadingWait');
	var loadingEl = document.getElementById('loading');
	if (loadingEl) loadingEl.style.display = 'none';
}
function loadingControl(){
	var skeletons = document.querySelectorAll('.am-skeleton');
	for (var i = 0; i < skeletons.length; i++) {
		if (skeletons[i].offsetParent !== null) {
			am_skeleton_takeover();
			return;
		}
	}
	if (document.body.classList.contains('loadingWait')) {
		$(document.body).addClassName('ajld');
		$(document.body).removeClassName('loadingWait');

	}
	// else{
	// 	$(document.body).removeClassName('ajld');
	// 	$(document.body).removeClassName('loadingWait');
	// }
}

// Show loading spinner on page navigation clicks
am.$(document).on('click', 'a[href]', function(e) {
	if (e.isDefaultPrevented()) return;
	if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
	var href = this.getAttribute('href');
	if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
	if (this.getAttribute('target') === '_blank') return;
	document.body.classList.add('ajld');
});

// DEV-12585: swallow a repeat click on a link that is ALREADY on its way. On a slow page
// users click the same link again (and again) while the first request is still running, and
// every one of those requests holds 3-4 MySQL connections for its whole life — a handful of
// them exhausts max_connections and the whole instance gets "Too many connections".
//
// Scoped deliberately to the SAME href within a short window. It is not a global click
// blocker: the #loading overlay used to be exactly that (full-viewport, z-index 9000, no
// pointer-events: none) and it ate clicks on links the user genuinely wanted, which is what
// DEV-12588 was. A different destination always goes through, immediately.
// Keyed by href, not just "the last link clicked": a user going A, B, then A again inside the
// window has still fired A twice, and the second A is the duplicate we want gone. Entries are
// pruned on each click so the map cannot grow.
var _navInFlight = {};
var NAV_DUPLICATE_WINDOW_MS = 2000;
am.$(document).on('click', 'a[href]', function(e) {
	if (e.isDefaultPrevented()) return;
	// A modifier click opens somewhere else and leaves this page in place, so it is never a
	// duplicate of a navigation happening here.
	if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
	var href = this.getAttribute('href');
	if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
	if (this.getAttribute('target') === '_blank') return;
	var now = new Date().getTime();
	for (var seen in _navInFlight) {
		if ((now - _navInFlight[seen]) >= NAV_DUPLICATE_WINDOW_MS) delete _navInFlight[seen];
	}
	if (_navInFlight[href]) {
		// preventDefault only — the spinner handler above still runs, so the user keeps
		// seeing that something is happening rather than the click looking ignored.
		e.preventDefault();
		return;
	}
	_navInFlight[href] = now;
});

function reports_prep(){
	if(!$('content') || !$('content').down('table.am-table')) return;
	$('content').down('table.am-table').onclick = function(){
		if(this.ignore){
			this.ignore = false;
		} else {
			$(this).select('tr.contains_detail').invoke('remove');
		}
	}
	$('content').down('table.am-table').select('table').each(function(tbl){
		var tr = tbl.up('tr'), parent_tr = tr.previous();
		parent_tr.addClassName('is_openable');
		parent_tr['hidden_child'] = tr.innerHTML;
		GUI.remove_div(tr);
		$(parent_tr).observe('click',reports_toggle_child);
	});
	GUI.zebrify($('maincontent').down('tbody').childElements());
}
function toggleCityCountyFilters(){
	var container = $('city-county-filters');
	if (!container) return;
	var codeFilters = $$("input.js-filter_checkbox[name='codes[]']");
	var hasSelectedCode = codeFilters.any(function(cb){ return cb.checked; });
	if (hasSelectedCode) {
		container.show();
	} else {
		container.hide();
		var cityInput = $('city-search');
		var countyInput = $('county-search');
		if (cityInput) cityInput.value = '';
		if (countyInput) countyInput.value = '';
	}
}
function clearLocationFilter(inputId){
	var input = $(inputId);
	if (!input) return;
	input.value = '';
	if (typeof salesTaxRealtimeFilter === 'function') {
		salesTaxRealtimeFilter();
	}
}
function close_table_placeholder_dynamically(ob) {
	// To detect the click to make sure the removal from DOM happens only if it is not from the info button.
	// I had to add does not contain case as the click can happen from many places, and it was the only way I could check.
	if (!ob.target.classList.contains('fa-clock')) {
		am.$('.table-placeholder table').remove();
		am.$('.table-placeholder').css('display', 'none');
		am.$('.table-placeholder')
			.each((index, single_placeholder) => single_placeholder.classList.remove('table-placeholder-open'));
	}
}

function reports_toggle_child(ob){
	close_table_placeholder_dynamically(ob);
	clear_expanded_table_data();
	if(!ob.element)
		return;
	if (Event.element(ob).tagName != 'TD') return;
	ob = ob?(ob.element?this:ob):this;
	ob.up('table')['ignore'] = true;
	if(!ob || !ob.hidden_child) return;
	if(ob.next() && ob.next().down('table'))
		GUI.remove_div(ob.next());
	else {
		const dataOrderId = ob.getAttribute('data-order-id');
		const tablePlaceholder = document.getElementById(`table_placeholder_${dataOrderId}`);

		if (dataOrderId && tablePlaceholder) {
			const moxtable = tablePlaceholder.querySelector('.am-table');
			if (moxtable) {
				moxtable.remove();
				tablePlaceholder.style.display = 'none';
			}
		}
		var current = ob.up('table').down('table');
		if(current && current.classList.contains('report_popdown')) GUI.remove_div(current.up('tr'));
		ob.insert({after:'<tr class="do_not_sort contains_detail '+ob.className+'">'+ob.hidden_child+'</tr>'});
		// Create a vertical buffer so that page will scroll down far enough to display info that extends outside of the viewport
		$('main').insert('<div id="expanded_data_scroll_buffer" class="noprint" style="height: ' + ($$('.report_popdown')[0].getHeight() + $$('.contains_detail')[0].cumulativeOffset().top - $('content_column').scrollHeight + ($('content_column').scrollHeight == $('content_column').getHeight() ? 150 : 0)) + 'px; width: 100%;"></div>');
		$('expanded_data_scroll_buffer').report_scroll_method = function()
		{
			var report_popdown = $$('.report_popdown');
			if(report_popdown.length)
				report_popdown[0].style.top = ($$('.contains_detail')[0].cumulativeOffset().top - $('content_column').scrollTop) + 'px';
		};
		$('expanded_data_scroll_buffer').report_scroll_method();
		$('content_column').observe('scroll', $('expanded_data_scroll_buffer').report_scroll_method);
	}
}
function reports_hide_all(tbl){
	var rrows = [];
	tbl.select('.do_not_sort').each(function(row){
		rrows.push(row.previous());
		GUI.remove_div(row);
	});
	return $A(rrows);
}
function reports_restore_open(rrows){
	$A(rrows).each(reports_toggle_child);
}

function make_tags_uneditable(){
	// This may not be reliable because it doesn't properly address the case when multiple tag clouds are present.  See multi_select.js initialize()
	try{
		tagsMultiSelect.element.setAttribute('data-allowCreationOfNewOptions', 0)
		delete tagsMultiSelect.options._object.allowCreationOfNewOptions;
	} catch (e){}
}

//TODO: move to contacts.js
function is_name_taken(ele, id){
	ele = $(ele) ? $(ele) : $('username');
	if(!$('username_is_unique') || !ele)
		return;
	$('username_is_unique').value = '';
	var mox = ele.up('form').mox;
	new Ajax.Request('/ajax/contacts/username_availability/', {
		parameters : {username : $F(ele), id: id },
		onSuccess : function(ret){
			if(ret.responseJSON == 1){
				$('username_is_unique').value = 1;
				mox.validate(true, 'username_is_unique');
			}else{
				$('username_is_unique').value = 0;
				if(!$('_username_is_unique'))
					mox.validate(false, 'username_is_unique', (get_language_translation('USERNAME_ALREADY_TAKEN') + '.'));
			}
		},
		onFailure : function(){
			$('username_is_unique').value = 0;
			mox.validate(false, 'username_is_unique', (get_language_translation('USERNAME_ALREADY_TAKEN') + '.'));
		}
	});
}
function show_help(topic, chapter, section, params) {
	var uri = ['help', topic, chapter].join('/') + '/'+ (params ? '?' + params : '') + (section ? "#"+section : "");
	const help = get_language_translation('LANG_NAVBAR_HELP');
	open_modal(uri,
	{
		title: help +'<a href="' + uri + '" onclick="return open_in_new_tab(this);"><i class="fas fa-external-link-alt"></i></a>',
		width: document.viewport.getWidth() * 0.8,
		height: document.viewport.getHeight() * 0.8,
		ok: false
	});
}
function show_rhelp(catalog_b, topic, chapter, section)
{
	show_help('catalog_b/' + catalog_b + '/' + topic, chapter, section);
}

// Show Simple Permission Alert
function permissionAlert(){
		   alert("You don't have necessary permission to edit this order.");
		   return false;
}

// conditionally Hide Right Sidebar and print the intended section
function printPage(hide_sidebar) {
	if(hide_sidebar) {
		$('rightside').addClassName('noprint');
		$('main').addClassName('printonly');
	}
	if($$('.zopim')[0])
	   $$('.zopim')[0].addClassName('noprint');
	window.print();
}

function toggle_more_help(container, arrow, speed) {
	container = typeof container !== 'undefined' ? (container === 'generic' ? 'generic_more_help' : container) : 'report_more_help';
	arrow = typeof arrow !== 'undefined' ? arrow : (container === 'generic_more_help' ? 'generic_show_hide_more_help' : 'report_show_hide_more_help');

	var arrowEl = document.getElementById(arrow);
	return generic_box_toggler(document.getElementById(container), arrowEl ? arrowEl.querySelector('*') : null, speed);
}

function tool_tip(element, bool){
	var tooltip = element.children ? element.children[0] : document.getElementsByClassName(element)[0].children[0]
		if(tooltip.style.visibility === ""||tooltip.style.visibility === "hidden"){
			if(!bool){
				tooltip.style.transition = "ease opacity 1s"
				tooltip.style.opacity = "1"
				tooltip.style.visibility = "visible"
				if(am.$("body").hasClass("am-breakpoint-small")){
					am.$("#content_column").css("overflow","hidden")
					am.$("#MB_content").css("overflow","hidden")
					am.$("#sidebar_content").css("overflow","hidden")
					
				}
			}
		}else{
			tooltip.style.transition = "ease opacity 1s visibility 1s"
			tooltip.style.opacity = ".5"
			tooltip.style.visibility = "hidden"
			if(am.$("body").hasClass("am-breakpoint-small")){
				am.$("#content_column").css("overflow","auto")
				am.$("#MB_content").css("overflow","auto")
				am.$("#sidebar_content").css("overflow","auto")
			}
		}
}

function generic_box_toggler(box, arrow, speed)
{
	if(!box)
		return false;
	var hidden = getComputedStyle(box).display === 'none';
	if(arrow)
	{
		arrow.classList.remove(hidden ? 'fa-angle-down' : 'fa-angle-up');
		arrow.classList.add(hidden ? 'fa-angle-up' : 'fa-angle-down');
	}
	box.style.display = hidden ? '' : 'none';
	return false;
}

function flipAll(box, arrow, flipped) {
	let boxes;
	if (typeof box === "string") {
		boxes = document.getElementsByClassName(box);
	} else {
		boxes = box;
	}

	const arrows = document.getElementsByClassName(arrow);
	for (let i = 0; i < boxes.length; i++) {
		const visible = getComputedStyle(boxes[i]).display !== 'none';
		if ((flipped === "close" && visible) || (flipped === "open" && !visible)) {
			generic_box_toggler(boxes[i], arrows[i]);
		}
	}
}

// generic browser detection code found in SO.
navigator.sayswho = (function () {
	var N = navigator.appName, ua = navigator.userAgent, tem;
	var M = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
	if (M && (tem = ua.match(/version\/([\.\d]+)/i)) != null) M[2] = tem[1];
	M = M ? [M[1], M[2]] : [N, navigator.appVersion, '-?'];
	return M;
})();

function show_browser_warning(session_show_warning) {
	if (session_show_warning) {
		var browser = navigator.sayswho;
		var browser_name = browser[0].toLowerCase();
		var browser_version = parseFloat(browser[1]);
		var show_warning = false;
		var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
		if (mobile) {
			show_warning = false;
		} else if (browser_name == 'msie' && browser_version < 9) {
			show_warning = true;
		} else if (browser_name == 'firefox' && browser_version < 18) {
			show_warning = true;
		} else if (browser_name == 'safari' && browser_version < 5) {
			show_warning = true;
		} else if (browser_name == 'chrome' && browser_version < 24) {
			show_warning = true;
		} else if (browser_name == 'opera' && browser_version < 11) {
			show_warning = true;
		}

		if (show_warning) {
			var error_div = new Element('p', {'class':'notice'}).update("Your browser isn't up to date, please update it to enjoy the full features of this site. <br />Click here to upgrade to the latest version of:<br />" + "<a href='https://www.google.com/intl/en/chrome/browser/'>Chrome</a><br /><a href='http://www.mozilla.org/firefox/?WT.mc_id=affiliates_banner&WT.mc_ev=click'>Firefox</a><br /><a href='http://www.apple.com/safari/'>Safari</a><br /> <a href='http://www.microsoft.com/windows/downloads/ie/getitnow.mspx'>Internet Explorer</a>");
			$('notifications').insert(error_div);

			// place ajax request to
			var url = 'ajax/dont_show_browser_warning/';
			new Ajax.Request(url, {
				onSuccess:function (transport) {

				},
				onFailure:function (transport) {

				}
			});
		}

	} else {
		return;
	}
}

function set_in_frame() {
	var in_frame = 0;
	if (window.self !== window.top) {
		var domain = window.location.toString().split('/')[2].split('.');
		var parent_domain = document.referrer.split('/')[2].split('.');
		if (parent_domain[1] != domain[1] || parent_domain[2] != domain[2])
			in_frame = 1;
	}
	new Ajax.Request('ajax/in_frame/', {
		parameters: {'in_frame':in_frame}
	});

}
function get_live_pdf(el, title, options) {

	if (!$('version')) {
		alert('Please wait for the page to finish loading before generating PDFs');
		return;
	}
	var data = Element.clone(el,true);
	data.select('.noprint').invoke('remove');
	var form = new Element('form',{'action':'pdf/','method':'post'})
		.insert(new Element('input',{'type':'hidden','name':'title','value': title.replace(/['"]+/g, '')}))
		.insert(new Element('input',{'type':'hidden','name':'html','value':data.innerHTML}));
	if (options) {
		if (options.open_new == 1)
			form.target = '_blank';
		if (options.landscape == 1)
			form.insert(new Element('input',{'type':'hidden','name':'landscape','value':1}))
		if (options.fl)
			form.insert(new Element('input',{'type':'hidden','name':'fl','value':options.fl}))
		if (options.fr)
			form.insert(new Element('input',{'type':'hidden','name':'fr','value':options.fr}))
		if (options.hidepagenum)
			form.insert(new Element('input',{'type':'hidden','name':'hide-page-num','value':options.hidepagenum}))
		if (options.size)
			form.insert(new Element('input',{'type':'hidden','name':'size','value':options.size.join(',')}))
		if (options.lrpmargin)
			form.insert(new Element('input',{'type':'hidden','name':'left_right_page_margin','value':options.lrpmargin}))
		if (options.tbpmargin)
			form.insert(new Element('input',{'type':'hidden','name':'top_bottom_page_margin','value':options.tbpmargin}))
		if (options.condensed)
			form.insert(new Element('input',{'type':'hidden','name':'condensed','value':options.condensed}))
	}
	document.body.appendChild(form);
	form.submit();
}

function toggle_all_table_data()
{
	var expand_data = $('expand_all_table_data').checked;
	var i = 0;


	clear_expanded_data_scroll_buffer();
	$$('.is_openable').each(function(tr)
	{
		// Hide any currently displayed pop-ups
		if(tr.hasClassName('contains_detail'))
		{
			GUI.remove_div(tr);
			return;
		}

		if(expand_data)
		{
			// Expand all pop-ups without any overlap
			var width;
			var row_id = 'expanded_data_row_' + i++;
			tr.insert({ after:'<tr id="' + row_id + '" class="do_not_sort contains_detail ' + tr.className + '">' + tr.hidden_child + '</tr>' });
			var expanded_data_table = $(row_id).down('table');
			$(row_id).onclick = function()
			{
				// Clicking any rows will clear all pop-ups in order to be compatible with the normal pop-up functionality
				clear_expanded_table_data();
			};

			if(expanded_data_table.hasClassName('order_id_table'))
				width = ($(row_id).getDimensions().width - expanded_data_table.getLayout().get('margin-left')) + 'px';
			else
				width = '100%';

			expanded_data_table.setStyle(
			{
				width: width
			});
			expanded_data_table.addClassName('expand_all');
		}
	});
}

function clear_expanded_table_data()
{
	if($('expand_all_table_data') && $('expand_all_table_data').checked)
	{
		$('expand_all_table_data').checked = false;
		toggle_all_table_data();
	}
	clear_expanded_data_scroll_buffer();
}

function clear_expanded_data_scroll_buffer()
{
	var buffer = $('expanded_data_scroll_buffer');
	if(buffer)
	{
		$('content_column').stopObserving('scroll', buffer.report_scroll_method);
		buffer.remove();
	}
}

// Automatically set export file extension when selecting data format, if user hasn't already entered extension.
function set_exporter_data_format(element)
{
	var default_ext = $F(element);
	if(!default_ext)
		return;

	var base_name = element.getAttribute('name').split('[')[0];
	var instance = (/\d+/).exec(element.getAttribute('name'))[0];
	var file_ext = $$('input[name="' + base_name + '[' + instance + '][extension]"]')[0];

	if(!$F(file_ext) || file_ext.getAttribute('data-automatic') == 1)
	{
		file_ext.value = default_ext;
		file_ext.setAttribute('data-automatic', 1);
	}
}

function get_node_index(element) // designed with table columns in mind
{
	var index = 0;
	var sibling = element.previousSibling;
	while(sibling !== null)
	{
		if(sibling.nodeType == 1)
			index++;
		sibling = sibling.previousSibling;
	}
	return index;
}

function to_string(the_var)
{
	switch(the_var)
	{
		case null:
		case undefined:
			return '';
		default:
			return the_var.toString();
	}
}

function html_safe(the_string)
{
	return to_string(the_string).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#039;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function launchChat() {
	window.open('https://app.purechat.com/w/cvo9kg','',' scrollbars=yes,menubar=no,width=500,height=596,resizable=no,toolbar=no,location=no,status=no');
}

// Create a vertical buffer on the sidebar to accommodate chat plug-ins.  This expects one of only two different
// plug-in containers, and positions are expected to be at the bottom-left or bottom-right of the screen.
function accommodate_chat_plugin()
{
	reposition_static_side_buttons();
	if(!$('rightside') || !$('chat_insert') || !$('chat_insert').down())
		return;

	var gap = $('chat_insert').getAttribute('data-gap');
	if(gap > 0)
	{
		if($('static_side_buttons')) // push buttons up
			$('static_side_buttons').insert('<div style="height: ' + gap + 'px;"></div>');
		else // push scrollable content up
			$('sidebar_content').insert('<div style="height: ' + gap + 'px;"></div>');
		return;
	}

	// Give chat module up to 5 seconds to initialize before giving up on detecting it
	var tries = 50;
	var interval_id = setInterval(set_static_side_buttons_height, 100);
	function set_static_side_buttons_height()
	{
		tries--;
		var chat_blob;
		var calc_height;

		if($('livechat-compact-container'))
		{
			chat_blob = $('livechat-compact-container');
			// Fix a stupid invisible obstruction
			var chat_child = $('livechat-compact-container').down();
			var chat_top = parseInt(chat_child.style.top);
			chat_child.style.top = 0;
			chat_blob.style.height = (chat_blob.getHeight() - chat_top) + 'px';
		}
		else if($$('.zopim').length > 0)
			chat_blob = $$('.zopim')[0];
		else if($('intercom-container'))
		{
			chat_blob = $('intercom-container');
			// Chat blob has no height, so its iframe must be measured
			var chat_child = $('intercom-container').down('.intercom-launcher-frame');
			var child_offset = chat_child.cumulativeOffset();
			calc_height = document.viewport.getDimensions().height - child_offset.top;
		}
		else
		{
			if(tries < 1)
				clearInterval(interval_id);
			return;
		}
		clearInterval(interval_id);

		var view_width = document.viewport.getWidth();
		var chat_offset = chat_blob.cumulativeOffset();
		var chat_right = view_width - chat_blob.getWidth() - chat_offset.left;
		var on_right = false;
		if(chat_offset.left > chat_right)
			on_right = true;

		var chat_obstructs = (on_right && !$('content_wrapper').hasClassName('farleft')) || (!on_right && $('content_wrapper').hasClassName('farleft'));

		if(chat_obstructs)
		{
			if(calc_height)
				var chat_height = calc_height;
			else
				var chat_height = chat_blob.getHeight();
			if($('static_side_buttons')) // push buttons up
				$('static_side_buttons').insert('<div style="height: ' + chat_height + 'px;"></div>');
			else // push scrollable content up
				$('sidebar_content').insert('<div style="height: ' + chat_height + 'px;"></div>');
			if(calc_height)
				reset_viewport_calcs(); // This became necessary when some instances started using Intercom
		}
	}
}

// Move sidebuttons out of the page's sidebar template content and into the generic sidebar
function reposition_static_side_buttons()
{
	if($('static_side_buttons'))
		$('sidebar_collapse').appendChild($('static_side_buttons'));
}

function sidebar_toggle()
{
	var toggler = $('content_wrapper');
	if(toggler.hasClassName('shutside'))
		toggler.removeClassName('shutside');
	else
		toggler.addClassName('shutside');
	reset_viewport_calcs();
	setTimeout(() => {// to handle sidebar animation
		init_snackbar_container();
	}, 500);
}

function sidebar_close()
{
	var toggler = $('content_wrapper');
	toggler.addClassName('shutside');
	reset_viewport_calcs();
	setTimeout(() => {// to handle sidebar animation
		init_snackbar_container();
	}, 200);
}

function reset_viewport_calcs()
{
	var h = document.viewport.getHeight();
	//var w = document.viewport.getWidth();
	var main = $('main');
	var marketpage = $('page1');
	var sidebutt = $('static_side_buttons');

	/* If stylesheets don't work...
	$('rightside').style.height = (h - 55) + 'px';
	*/
	if(main || marketpage)
		$('sidebar_content').style.height = (h - 105 - (sidebutt ? sidebutt.getHeight() : 0)) + 'px';
	// Stylesheets don't quite work in Safari
	if(navigator.sayswho[0] === 'Safari' && $('content_wrapper'))
	{
		var new_h = h - 55;
		$('page_wrapper').style.height = h + 'px';
		$('content_wrapper').style.height = new_h + 'px';
		$('content_column').style.height = new_h + 'px';
		$('rightside').style.height = new_h + 'px';
	}
	if(marketpage)
	{
		var _topBar = $('top-bar');
		var _topBarH = _topBar ? _topBar.getHeight() : 0;
		$$('.page, .page iframe').invoke('setStyle', { height: (h - 55 - _topBarH) + 'px' });
	}
}

function printer_friendly_version()
{
	$(document.body).update($('maincontent').insert(
	{
		'top': new Element('a',
		{
			class: 'noprint',
			href: 'javascript: location.reload(true);'
		}).update('Back')
	}));
	return false;
}


function collapse_all_sidebar_subcontainers(element)
{
	$$('.sidebar_subcontainer').each(function(el)
	{
		var prev = el.previous();
		if(prev.innerHTML === element.innerHTML)
			return;
		if(prev.hasClassName('close'))
			GUI.blind_toggle(el, prev);
	});
}

// Makes graphical checkboxes keyboard-friendly
function tabstop_graphical_checkboxes()
{
	$$('input.cb2').each(function(el)
	{
		// Assuming parent is always a LABEL since that's how it's supposed to be used
		var label = el.up();
		if(label.hasAttribute('tabindex'))
			return;
		label.setAttribute('tabindex', '0');
		label.observe('keyup', function(event)
		{
			if(event.keyCode == 32)
			{
				el.checked = !el.checked; // Doesn't raise click event
				//el.simulate('click'); // Use this line instead of previous if using event.simulate.js
			}
		});
	});
}

// DEV-13187: picked-file state for the certified file-upload part (.am-upload).
// file_input_changed() below shows the picked filename by writing into the legacy
// <label class="file"> element's own <span>; the certified zone has no such span, so a
// picked file rendered nothing (the Import Order upload step lost its confirmation).
// The part's picked state is a certified .am-upload-file row in the sibling
// .am-upload-list (design-system components/file-upload.css): type glyph, filename,
// trailing remove. The remove button clears the input and drops the row.
function am_upload_file_changed(e){
	const input = e.target;
	const zone = input.closest ? input.closest('.am-upload') : null;
	if(!zone || !zone.parentElement)
		return false;
	const list = zone.parentElement.querySelector('.am-upload-list');
	if(!list)
		return false;
	const shell = list.closest('.am-table-shell') || list;
	const removeLabel = list.getAttribute('data-remove-label') || 'Remove';
	const files = Array.prototype.slice.call(input.files || []);
	list.innerHTML = '';
	files.forEach(function(file){
		const row = document.createElement('div');
		row.className = 'am-upload-file';
		row.innerHTML = '<span class="am-icon am-upload-file__glyph" data-icon="draft" aria-hidden="true"></span>'
			+ '<div class="am-upload-file__body"><span class="am-upload-file__name"></span></div>'
			+ '<span class="am-upload-file__meta"><button type="button" class="am-upload-file__cancel"><span class="am-icon" data-icon="close" aria-hidden="true"></span></button></span>';
		row.querySelector('.am-upload-file__name').textContent = file.name;
		const remove = row.querySelector('.am-upload-file__cancel');
		remove.setAttribute('aria-label', removeLabel + ' ' + file.name);
		remove.addEventListener('click', function(){
			input.value = '';
			row.remove();
			if(!list.children.length){
				shell.hidden = true;
				zone.classList.remove('selected');
				if(input.getAttribute('data-disabled_btn'))
					am.$(input.getAttribute('data-disabled_btn')).prop('disabled', true);
			}
		});
		list.appendChild(row);
	});
	shell.hidden = files.length === 0;
	zone.classList.toggle('selected', files.length > 0);
	if(input.getAttribute('data-disabled_btn'))
		am.$(input.getAttribute('data-disabled_btn')).prop('disabled', files.length === 0);
	return true;
}

// DEV-13187 (QA send-back): the certified zone reads "Drag and drop a file here" but the
// DEV-12502 port never wired the drop - the browser just opened the file. Delegated once
// for every .am-upload zone: dragover paints the part's is-dragover state, drop hands the
// file(s) to the zone's own <input type=file> and fires its change handler, so the
// picked-file row renders exactly as a click-pick does. A single-file input takes the
// first dropped file only.
(function am_upload_dropzone(){
	function zoneOf(e){ return (e.target && e.target.closest) ? e.target.closest('.am-upload') : null; }
	document.addEventListener('dragover', function(e){
		const zone = zoneOf(e); if(!zone) return;
		e.preventDefault(); zone.classList.add('is-dragover');
	});
	document.addEventListener('dragleave', function(e){
		const zone = zoneOf(e); if(!zone) return;
		if(!e.relatedTarget || !zone.contains(e.relatedTarget)) zone.classList.remove('is-dragover');
	});
	document.addEventListener('drop', function(e){
		const zone = zoneOf(e); if(!zone) return;
		e.preventDefault(); zone.classList.remove('is-dragover');
		const input = zone.querySelector('input[type=file]');
		const dropped = e.dataTransfer ? e.dataTransfer.files : null;
		if(!input || !dropped || !dropped.length) return;
		try{
			if(input.multiple || dropped.length === 1){
				input.files = dropped;
			}else{
				const dt = new DataTransfer(); dt.items.add(dropped[0]); input.files = dt.files;
			}
		}catch(err){ return; }
		input.dispatchEvent(new Event('change', {bubbles: true}));
	});
})();

function file_input_changed(e){	
	if(am_upload_file_changed(e))
		return;
	const target = am.$(e.target);
	const previewBox = am.$(target.parent()).parent();
	//if there's ever a need for a progress bar...
	// const progressBar = am.$("<progress>");
	// progressBar.attr({"value":0, "max":100});
	// previewBox.children(".am-progressBar").append(progressBar);
	//if(element.value.length)
	var errormsg = '';
	var continuousprocess = true;
	if(target.data('validext') && target.data('validext').length > 0){
		var fileTypes = target.data('validext'); 
		var extension = e.target.files[0].name.split('.').pop().toLowerCase();  //file extension from input file
		var isSuccess = fileTypes.indexOf(extension) > -1; 
		continuousprocess = isSuccess;
		if(isSuccess == false){
			errormsg = extension + ' Is not a valid file type, only (' + fileTypes + ') are valid;';
		}

	}
	
	if(continuousprocess){
		//if there's ever a need for a progress bar...
		// const progressBar = am.$("<progress>");
		// progressBar.attr({"value":0, "max":100});
		// previewBox.children(".am-progressBar").append(progressBar);
		//if(element.value.length)
		const label = am.$(e.target).parent();
		label.addClass('selected');
		var labelText = label.children("span");
			labelText.text(e.target.files[0].name);
		if(target.parent().attr("data-imagePreview")){
			const imageBox = previewBox.children(".am-image-upload-container");
			const noImageBox = previewBox.children(".am-noimage-container");
			const image = am.$(imageBox).children("img");
			let fileReader = new FileReader();
			//progressBar
			// fileReader.addEventListener('progress', progression); 
			// fileReader.addEventListener('load', complete); 
			fileReader.onload = ()=>{
				let fileURL = fileReader.result;
				const appear = ()=>imageBox.css("display", "flex");
				const disappear= ()=>noImageBox.css("display","none");
				const types = label.parent().children(".file-perams");
				const show = ()=>types.addClass("file-perams--show").removeClass("file-perams--hide");
				am.$(image).attr("src", fileURL);
				ensureGSAP().then(function(){
					gsap.to(noImageBox, {opacity:0, onComplete:disappear});
					gsap.to(imageBox, {opacity:1, onStart:appear}, ">");
					gsap.to(types, {onComplete:show});
				});
			}
			fileReader.readAsDataURL(e.target.files[0]);
		}
		//ProgressBar
		// function progression(event){
		// 	let percent =( (event.loaded/event.total) * 100);
		// 	progressBar.attr("value",Math.round(percent));
		// }
		// function complete(){
		// 	progressBar.remove();
		// }
		
		//else // Change event not fired when value is cleared directly; probably not needed for this project anyway.
		//	element.up().removeClassName('selected');
	}
	else{
		show_snackbar({
			message: errormsg,
			type: 'danger',
			show_close: true,
			autoClose: true,
			timer: 7500
		}); 
	}
	
}

// Filter non-unique values out of an array.  Call via array.filter(array_filter_unique);
function array_filter_unique(value, index, self)
{
	return self.indexOf(value) === index;
}

/**
 * Collect input values into a single object.  (Input elements must have attribute NAME!)
 * @param mixed selector  Selector of parent container (doesn't have to be a form).
 * @return object
 */
function form_to_object(selector)
{
	var inputs = {};
	var form = $$(selector);
	if(form.length > 0)
		form = form[0];
	else
		return inputs;

	form.select(':input[name]').each(function(element)
	{
		var name = '';
		var value = '';
		name = element.getAttribute('name');
		switch(element.getAttribute('type'))
		{
			case 'checkbox':
				value = 0 + (element.checked);
				break;
			case 'file':
				console.log('form_to_object() is not suitable for collecting file inputs! (' + name + ')');
				return;
			case 'radio':
				value = $('input[name=' + name + ']:checked').value;
				break;
			default:
				value = element.value;
		}
		if(value === undefined)
			value = null;

		if(name.indexOf('[') > -1) // input belongs to an array
		{
			var names = name.replace(/]/g, '').split('[');
			inputs = form_to_object_array_member(inputs, names, value);
		}
		else
			inputs[name] = value;
	});

	return inputs;
}

/**
 * Build an object array member from an element with an array for a name, e.g. <INPUT NAME="billy[bob][]" />.
 * @param object obj   Object being built on.
 * @param array names  The source element's name already split into an array.
 * @param mixed value  The value to be assigned at the end of the array chain.
 * @return object
 */
function form_to_object_array_member(obj, names, value)
{
	var name = names.shift();

	if(name.length == 0) // non-specifically integer-indexed array
	{
		obj[Object.keys(obj).length] = value; // will not work in IE<9
	}
	else
	{
		if(obj[name] === undefined)
			obj[name] = {};
		if(names.length == 0)
			obj[name] = value;
		else
			obj[name] = form_to_object_array_member(obj[name], names, value);
	}

	return obj;
}

// Make hyperlinks that open-in-new-tab when clicked but can still be middle-clicked
function open_in_new_tab(anchor)
{
	window.open(anchor.href, '_blank').focus();
	return false;
}


window.onerror = function(msg, url, line) {
	if(console && console.log)
		console.log(['Unhandled Exception:', msg, ' URL:', url, 'Line Number:', line, ' (breakpoint at the end of site.js for more info)'].join(' '));
	return false;
}

function fadeout(container)
{
    var op = 1;

    var timer = setInterval(() => {
        if (op <= 0.0)
        {
            clearInterval(timer);
        }
        container.style.opacity = op;
        op -=0.1;
    }, 1);
}

function fadein(container)
{
    var op = 0.0;

    var timer = setInterval(() => {
        if (op >= 1)
        {
            clearInterval(timer)
        }
        container.style.opacity = op;
        op += 0.1;
    }, 100)
}

function removeImage(e){
	const $target = am.$(e.target);

	// Sets input type=file to nothing on removal of added img
	const $trueInput = am.$('#' + $target.data('toremove'));
	$trueInput.val('');

	const area = $target.parent().closest(".am-img-upload-area")
	const span = area.children("label").children("span");
	const types = area.children(".file-perams");
	span.text(get_language_translation('LANG_LABEL_CHOOSE_FILE'));
	const input = $target.siblings("input");
	am.$(input).val('true');
	const imageBox = $target.parent();
    const noImageBox = imageBox.siblings(".am-noimage-container");
    const image = am.$(imageBox).children("img") ;
	const disappear = ()=>imageBox.css("display", "none");
	const appear = ()=>noImageBox.css("display","block");
	const show = ()=>types.addClass("file-perams--hide").removeClass("file-perams--show");
	ensureGSAP().then(function(){
		gsap.to(types, {onComplete:show});
		gsap.to(imageBox, {opacity:0, onComplete:disappear});
		gsap.to(noImageBox, {opacity:1, onStart:appear}, ">");
	});
}

function lazyImageLoad() {
	am.$('.lazyImage').each(function() {
	  const $img = am.$(this);
	  const originalSrc = $img.data('src');
	  if (!$img.hasClass('lazyImage_loaded')){
		const tempImage = new Image();
		tempImage.onload = function() {
			$img
			.fadeOut(400, function() {
				$img.attr('src', originalSrc);
			})
			.fadeIn(400);
			$img.removeAttr('data-src');
			$img.addClass('lazyImage_loaded').removeClass('lazyImage');
		};
		tempImage.src = originalSrc;
	  }
	});
  }

function mobileToolTip(){
	if(am.$('body').hasClass('device_ismobile_true')){
		am.$("i[data-bs-toggle='tooltip']").each(function(){
			am.$(this).attr('data-bs-trigger', 'click');
		});
	}
}

function adjust_footer(){
	try{
		am.$('#footer').addClass('footer-sticky-button');
	}catch(e){
		console.log(e)
	}
}

function check_height($body){
	if(am.$('#terms_form').length > 0){
		if($body.hasClass('am-breakpoint-small') || $body.hasClass('am-breakpoint-medium'))
			return '64px';
		else
			return '58px';
	}
	else
		return '58px';
}

function getCurrentBaseUrl() {
    const currentUrl = window.location.href;
	const anchor = document.createElement('a');
    anchor.href = currentUrl;

    return anchor.protocol + '//' + anchor.hostname;
}

document.addEventListener('click', function (e) {
	if (!e.target.closest('.am-status-dropdown')) {
		document.querySelectorAll('.am-status-dropdown[open]').forEach(function (el) {
			el.open = false;
		});
	}
});

window.addEventListener('DOMContentLoaded', (event) => {
	// Critical — affects above-fold rendering
	breakpointClass();
	lazyImageLoad();
	lazyloadBackgroundImages();

	// Non-critical — defer until browser is idle
	var deferWork = window.requestIdleCallback || function(cb) { setTimeout(cb, 1); };
	deferWork(function() {
		appcuesCheck();
		mobileToolTip();
		select_children_tree();
		try { init_category_trees(); } catch(e) {}
		try { showSelectedItemsWithParents(); } catch(e) {}
	});
});

am.$( window ).resize(function() {
	breakpointClass();
	lazyloadBackgroundImages();
	mobileToolTip();
});

function is_dev_mode() {
	return document.body.getAttribute("data-dev-mode") === "true";
}
